<template>
  <div class="home fadeIn animate-time">
    <div class="con">
      <img src="./imgs/home.png" alt="">
      <p class="tt">了解更多雷小安请下载App</p>
      <img class="img_b" src="./imgs/more.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: "Home",
  data() {
    return {
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .con {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 50px;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .tt{
      font-size: 32px;
      font-weight: 600;
      text-align: center;
    }
    .img_b{
      margin-bottom: 70px;
    }
  }
  &_content {
    // background-image: url('../assets/web-bg.png');
    width: 100%;
    height: 100%;
		position: fixed;
		background-repeat: no-repeat;
		background-position: 0px 0px;
		background-size: 100% 100%;
		font-size: 30upx;
  }
  &_link {
    position: fixed;
    left: 50%;
    bottom: 40px;
    transform: translate(-50%, 0);
    z-index: 99;
    font-size: 16px;
    // color: #ffffff;
    font-weight: 'bold';
    cursor: pointer;
  }
}
</style>
